const RemSizes = (number) => {
  const remCalculated = number / 16;
  return `${remCalculated.toString()}rem`;
};
export {
  RemSizes
};
//# sourceMappingURL=utils.js.map
